import {
  BoundaryErrorPage,
  ConfirmationModal,
  useVersionReload,
} from "@synota-io/synota-shared-ui";
import { ErrorBoundary } from "@sentry/react";
import { AppRoutes } from "./AppRoutes";

export const App = () => {
  const { modal, onReload, refetch } = useVersionReload({ currentVersion: APP_VERSION });

  return (
    <ErrorBoundary
      onError={() => refetch()}
      fallback={({ eventId }) => (
        <BoundaryErrorPage eventId={eventId} onReload={onReload}>
          <ConfirmationModal {...modal} preventCloseOnBackdropClick />
        </BoundaryErrorPage>
      )}
    >
      <AppRoutes />
      <ConfirmationModal {...modal} preventCloseOnBackdropClick />
    </ErrorBoundary>
  );
};
